module.exports = __webpack_public_path__ + "site/img/index1zh11.7ba79b4b.jpg";